import useAuthUser from "@/composables/useAuthUser";
import { RouteRecordRaw } from "vue-router";
import ContactTypePage from "../pages/contact-type/IndexPage.vue";
import ProviderHotelPage from "../pages/hotel/ProviderHotelPage.vue";
import { default as BrandProviderRoutes } from "../pages/hotel/brands/routes/brandProvider.routes";
import { default as ChainProviderRoutes } from "../pages/hotel/chain/routes/chainProvider.routes";
import { default as GroupsProviderRoutes } from "../pages/hotel/group/routes/groupsProvider.routes";
import { default as HotelProviderRoutes } from "../pages/hotel/hotels/routes/hotelProvider.routes";

export default {
  path: "/internal/providers",
  beforeEnter: (to, from, next) => {
    const { user } = useAuthUser();

    if (!user.value?.internal) {
      return next({
        path: "/error/not-found",
      });
    } else {
      next();
    }
  },
  children: [
    {
      path: "hotel",
      children: [
        {
          path: "",
          name: "hotel",
          component: ProviderHotelPage,
        },
        GroupsProviderRoutes,
        ChainProviderRoutes,
        BrandProviderRoutes,
        HotelProviderRoutes,
      ],
    },
    {
      path: "contact-type",
      children: [
        {
          path: "",
          name: "contact-type",
          component: ContactTypePage,
        },
      ],
    },
  ],
} as RouteRecordRaw;
